import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { toast } from "react-toastify";

function MuxDeleteAction({ item, onUpdate }: any) {
  const [loading, setLoading] = useState(false);

  const { fetchData: fetchResetTalktapeData } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/performances/mux/${item.performance_id}/delete`,
    method: "PUT",
  });

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this talktape?")) return;

    setLoading(true);
    try {
      const response = await fetchResetTalktapeData( {delete_param: "delete-upload"});
      
      const result = response.success;
      if (!result) {
        throw new Error("Failed to reset talktape status");
      }

      if (onUpdate) {
        onUpdate({
          ...item,
          mux_playback_id: null,
          mux_asset_id: null, 
          mux_playback_url: null,
          status: null
        });
      }

      toast.info(response.message);
    } catch (error) {
      console.error("Error deleting talktape:", error);
      alert("Failed to delete talktape. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Delete Talktape" enterDelay={0} leaveDelay={0}>
      <span>
      <DeleteOutlineIcon
        className="music-icon remove"
        onClick={handleDelete}
        style={{
          cursor: "pointer",
          opacity: loading ? 0.5 : 1,
          color: loading ? "#ccc" : "#d32f2f",
        }}
      />
    </span>
    </Tooltip>
  );
}

export default MuxDeleteAction;